/* src/app/main/pages/apps/freight-volume-calculator/freight-volume-calculator.component.css */
.contaier-specification-banner-row {
  background-image:
    linear-gradient(
      to left,
      rgb(255 255 255 / 0),
      rgb(33 54 84 / 0.5)),
    url(/assets/images/apps/apps-banner-img.png);
  height: 600px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
.contaier-specification-banner-row h1 {
  font-size: 56px;
}
.contaier-specification-banner-row .fa-plane {
  color: #AAAAAA;
  background-color: #fff;
  padding: 10px 8px;
}
.app-img {
  width: 65px;
  height: 65px;
}
.back-link {
  color: #E8882D;
  font-family: "D-DIN";
  font-size: 16px;
}
.back-link .fa-angle-left {
  font-weight: 600;
}
.freight-vol-calc-group {
  background-color: #213654;
  padding: 8px 10px;
  margin-bottom: 25px;
  box-shadow: 0px 3px 6px #00000029;
}
.freight-vol-calc-group label {
  margin-right: 10px;
  margin-bottom: 0px;
  font-weight: 600;
}
.freight-vol-calc-group .cust-input {
  font-size: 15px;
  height: auto;
  border-radius: 0;
  padding: 3px 10px;
  border: none;
  margin-right: 10px;
  font-family: "D-DIN";
  width: 84%;
}
.dimension-calculator .cust-input,
.unit-convertor .cust-input {
  font-size: 14px;
  height: auto;
  border-radius: 0;
  padding: 8px 12px;
  border: none;
  font-family: "Roboto";
  border-radius: 0;
  background-color: #F0F0F0;
  border-left: 3px solid #213654 !important;
  border: 1px solid rgb(11 42 125 / 0.2);
  color: #505050;
}
.dimension-calculator select,
.unit-convertor select {
  padding: 8px 9px;
}
.unit-convertor .cust-input {
  margin-bottom: 15px;
}
.unit-convertor::-webkit-input-placeholder,
.dimension-calculator::-webkit-input-placeholder {
  color: #505050;
}
.unit-convertor:-ms-input-placeholder,
.dimension-calculator:-ms-input-placeholder {
  color: #505050;
}
.unit-convertor::placeholder,
.dimension-calculator::placeholder {
  color: #505050;
}
.unit-convertor .calc-result::-webkit-input-placeholder {
  color: #fff;
}
.unit-convertor .calc-result:-ms-input-placeholder {
  color: #fff;
}
.unit-convertor .calc-result::placeholder {
  color: #fff;
}
.dimension-calculator .btn-search {
  background-color: #E8882D;
  border: none;
  color: #FFFFFF;
  border-radius: 0px;
  box-shadow: 0px 3px 6px #00000029;
  font-size: 14px;
  padding: 8px 36px;
  font-family: "D-DIN-Bold";
  margin-right: 60px;
}
.bg-gray {
  background-color: #F5F5F5;
  box-shadow: 0px 3px 6px #00000029;
}
.yellow-bg {
  background-color: #E8882D;
  padding: 10px 60px 10px 20px;
  box-shadow: 0px 3px 6px #00000029;
  margin-top: 20px;
}
.grand-total .form-control {
  width: auto;
  margin-right: 15px;
}
.unit-convertor p {
  background-color: #2B2B2B;
  color: #fff;
  margin-bottom: 0;
  padding: 10px 20px;
}
.calc-result {
  margin-top: 15px;
  background-color: #E8882D !important;
  box-shadow: 0px 3px 6px #00000029;
  color: #FFFFFF !important;
  border-radius: 0;
  border: none;
  border-left: 1px solid #213654 !important;
  font-size: 14px;
}
.calc-result.border-none {
  border-left: none !important;
}
.freight-vol-calc-group img {
  width: 22px;
  height: 22px;
  margin-right: 10px;
}
.freight-volume-calculator label {
  font-weight: 600;
}
@media (min-device-width: 1600px) {
  .freight-vol-calc-group h6 {
    font-size: 20px;
  }
  .freight-vol-calc-group {
    padding: 12px 15px;
  }
}
@media (min-device-width: 1440px) {
  .freight-vol-calc-group img {
    width: 25px;
    height: 25px;
  }
  .freight-volume-calculator label {
    font-size: 18px;
  }
  .dimension-calculator .cust-input,
  .unit-convertor .cust-input {
    font-size: 17px;
  }
  .unit-convertor p {
    font-size: 18px;
  }
  .grand-total h6 {
    font-size: 18px;
  }
  .calc-result {
    font-size: 17px;
  }
}
@media (device-width: 1440px) {
  .freight-vol-calc-group h6 {
    font-size: 20px;
  }
}
@media (max-width: 767px) {
  .freight-vol-calc-group label,
  .apps-form-result label {
    width: 100%;
  }
  .card-img-top {
    margin-top: 10px;
  }
  .back-link {
    margin-bottom: 5px;
  }
  .yellow-bg {
    padding: 20px 30px 10px 30px;
  }
  .yellow-bg h6 {
    margin-bottom: 15px !important;
  }
  .grand-total .form-control {
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }
  .bg-gray {
    margin-bottom: 30px;
  }
}
.invalid-feedback {
  display: block;
  position: absolute;
  margin-top: -22px;
}
.invalid-feedback.invalid_1 {
  position: absolute;
  margin: 0px;
}
.calResult {
  position: relative;
}
.calResult .loader {
  position: absolute;
  width: 100%;
  margin: auto;
  text-align: center;
  padding: 7px;
  color: #000;
  background-color: #ebebeb;
  opacity: 0.8;
}
.border-right {
  border-right: 1px solid #dee2e6 !important;
}
/*# sourceMappingURL=freight-volume-calculator.component.css.map */
